import styled from "styled-components";

import { IThemeProps } from "@/styles/Theme";

/* ------------------------------ Poll body ------------------------------ */

export const Section = styled.section<IThemeProps>`
  display: block;
  margin: 0 auto;
  width: 100%;
  max-width: 510px;
  @media ${(props: IThemeProps) => props.theme.breakpoints.mobile} {
    max-width: 310px;
  }

  padding: ${(props: IThemeProps) => props.theme.spacing.desktop.s500}px
    ${(props: IThemeProps) => props.theme.spacing.desktop.s800}px;

  @media ${(props: IThemeProps) => props.theme.breakpoints.mobile} {
    padding: ${(props: IThemeProps) => props.theme.spacing.mobile.s500}px
      ${(props: IThemeProps) => props.theme.spacing.mobile.s500}px;
  }
`;

export type PollOptionsWrapperProps = IThemeProps<{ $noMarginTop: boolean }>;
export const PollOptionsWrapper = styled.div<PollOptionsWrapperProps>`
  display: flex;
  margin: 0 auto;
  align-items: center;
  justify-content: space-between;
  flex-flow: wrap;
  margin-top: ${(props: PollOptionsWrapperProps) =>
    props.$noMarginTop ? 0 : props.theme.spacing.desktop.s500}px;
  max-width: 384px;
`;

export const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 15px 0;
  @media ${(props: IThemeProps) => props.theme.breakpoints.mobile} {
    margin: 10px 0;
  }
`;

export const Label = styled.div`
  text-align: center;
  font-size: 12px;
  color: ${(props: IThemeProps) =>
    props.theme.colors.pollMultipleChoiceLabelColor};
  background: ${(props: IThemeProps) =>
    props.theme.colors.pollMultipleChoiceLabelBackground};
  padding: 3px;
`;
